import { Link } from "react-router-dom";
import PageMeta from "./PageMeta";

const channels = [
  {
    handle: "@REDRUTHSEAANGLINGASSOCIATION",
    url: "https://www.youtube.com/@REDRUTHSEAANGLINGASSOCIATION",
    name: "Redruth Sea Angling Association",
    category: "Club Channel",
    description: "Our own club channel — catch reports and highlights from RSAA members, including this session with Enzo Dale landing tope, huss, bass and greater weaver.",
  },
  {
    handle: "@TheFishLocker",
    url: "https://www.youtube.com/@TheFishLocker",
    name: "The Fish Locker",
    category: "UK Sea Fishing",
    description: "UK sea fishing adventures, tackle reviews, and tips covering a wide range of species from shore and boat.",
  },
  {
    handle: "@FrugalOutdoors",
    url: "https://www.youtube.com/@FrugalOutdoors",
    name: "Frugal Outdoors",
    category: "Budget Fishing",
    description: "Proving that great fishing doesn't have to cost a fortune — budget-friendly kit, tips and honest reviews.",
  },
  {
    handle: "@obanonthewater7796",
    url: "https://www.youtube.com/@obanonthewater7796",
    name: "OB Anon on the Water",
    category: "UK Sea Fishing",
    description: "Shore and boat fishing sessions around the UK coast, with natural commentary and genuine catches.",
  },
  {
    handle: "@TheShoreHunter",
    url: "https://www.youtube.com/@TheShoreHunter",
    name: "The Shore Hunter",
    category: "Shore Fishing",
    description: "Shore fishing tactics, mark-finding, and catch reports — a go-to channel for UK beach and rock anglers.",
  },
  {
    handle: "@bassmansbountyfishing",
    url: "https://www.youtube.com/@bassmansbountyfishing",
    name: "Bassman's Bounty Fishing",
    category: "Bass Fishing",
    description: "Dedicated bass fishing content covering lure work, plugging and wading the surf for UK bass.",
  },
  {
    handle: "@thesolentwarrior",
    url: "https://www.youtube.com/@thesolentwarrior",
    name: "The Solent Warrior",
    category: "UK Sea Fishing",
    description: "Fishing the Solent and surrounding South Coast waters for bass, bream, smoothhound and more.",
  },
  {
    handle: "@kayak_fishing_Cornwall",
    url: "https://www.youtube.com/@kayak_fishing_Cornwall",
    name: "Kayak Fishing Cornwall",
    category: "Cornwall / Kayak",
    description: "Kayak fishing adventures from the beautiful and rugged waters of Cornwall — local and close to home.",
  },
  {
    handle: "@thehumantrawler5162",
    url: "https://www.youtube.com/@thehumantrawler5162",
    name: "The Human Trawler",
    category: "UK Sea Fishing",
    description: "Enthusiastic sea fishing sessions from shore and boat with a focus on enjoying every species caught.",
  },
  {
    handle: "@TAFishing",
    url: "https://www.youtube.com/@TAFishing",
    name: "TA Fishing",
    category: "UK Fishing",
    description: "A varied fishing channel covering sea, predator and coarse fishing across the UK with great production.",
  },
  {
    handle: "@TheFalAnglers",
    url: "https://www.youtube.com/@TheFalAnglers",
    name: "The Fal Anglers",
    category: "Cornwall",
    description: "Local angling around the Fal estuary and Falmouth area — familiar marks, familiar faces.",
  },
  {
    handle: "@SlippyLimpets",
    url: "https://www.youtube.com/@SlippyLimpets",
    name: "Slippy Limpets",
    category: "Shore Fishing",
    description: "Rock and shore fishing adventures along the UK coastline with honest, down-to-earth content.",
  },
  {
    handle: "@CornishFishingTales-dc4rw",
    url: "https://www.youtube.com/@CornishFishingTales-dc4rw",
    name: "Cornish Fishing Tales",
    category: "Cornwall",
    description: "Fishing stories, catches and local knowledge from the Cornish coastline — a real taste of home.",
  },
  {
    handle: "@savagegearuk1063",
    url: "https://www.youtube.com/@savagegearuk1063",
    name: "Savage Gear UK",
    category: "Tackle Brand",
    description: "The official UK channel for Savage Gear — lure fishing inspiration, product launches and pro angler content.",
  },
  {
    handle: "@soultee-uk",
    url: "https://www.youtube.com/@soultee-uk",
    name: "Soultee UK",
    category: "Lure Fishing",
    description: "UK lure fishing and light tackle adventures, with a focus on style, technique and great fish.",
  },
  {
    handle: "@Ukpredatorfishing",
    url: "https://www.youtube.com/@Ukpredatorfishing",
    name: "UK Predator Fishing",
    category: "Predator Fishing",
    description: "Pike, perch, zander and all things UK predator fishing — tactics, venues and big fish catches.",
  },
  {
    handle: "@theportsmouthangler7297",
    url: "https://www.youtube.com/@theportsmouthangler7297",
    name: "The Portsmouth Angler",
    category: "UK Sea Fishing",
    description: "Shore and sea fishing from Portsmouth and the surrounding South Coast — local knowledge and honest catch reports.",
  },
];

const categoryColors = {
  "Club Channel":      "text-red-300     border-red-300/30     bg-red-400/10",
  "UK Sea Fishing":    "text-cyan-300    border-cyan-300/30    bg-cyan-400/10",
  "Shore Fishing":     "text-sky-300     border-sky-300/30     bg-sky-400/10",
  "Bass Fishing":      "text-emerald-300 border-emerald-300/30 bg-emerald-400/10",
  "Cornwall":          "text-amber-300   border-amber-300/30   bg-amber-400/10",
  "Cornwall / Kayak":  "text-amber-300   border-amber-300/30   bg-amber-400/10",
  "Predator Fishing":  "text-rose-300    border-rose-300/30    bg-rose-400/10",
  "Lure Fishing":      "text-violet-300  border-violet-300/30  bg-violet-400/10",
  "Tackle Brand":      "text-slate-300   border-slate-300/30   bg-slate-400/10",
  "Budget Fishing":    "text-lime-300    border-lime-300/30    bg-lime-400/10",
  "UK Fishing":        "text-blue-300    border-blue-300/30    bg-blue-400/10",
};

function YouTubeIcon({ className }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );
}

function ChannelCard({ channel }) {
  const badgeClass =
    categoryColors[channel.category] ||
    "text-slate-300 border-slate-300/30 bg-slate-400/10";

  return (
    <a
      href={channel.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex flex-col gap-3 rounded-2xl border border-white/10 bg-white/5 p-6 text-left transition hover:border-red-400/40 hover:bg-red-500/5 h-full panel-lift"
    >
      <div className="flex items-start justify-between gap-3">
        <span className={`self-start rounded-full border px-3 py-0.5 text-xs font-semibold ${badgeClass}`}>
          {channel.category}
        </span>
        <YouTubeIcon className="h-5 w-5 shrink-0 text-slate-600 transition group-hover:text-red-500" />
      </div>

      <p className="text-base font-bold text-white leading-snug">{channel.name}</p>
      <p className="text-xs text-slate-500 font-mono">{channel.handle}</p>

      {channel.description && (
        <p className="text-xs text-slate-400 leading-relaxed">{channel.description}</p>
      )}

      <div className="mt-auto">
        <span className="inline-flex items-center gap-1.5 text-xs text-red-400 font-medium transition group-hover:text-red-300">
          <YouTubeIcon className="h-3.5 w-3.5" />
          Watch on YouTube
        </span>
      </div>
    </a>
  );
}

export default function YouTubePage() {
  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="YouTube Channels | Redruth Sea Angling Association"
        description="Watch Redruth Sea Angling Association's YouTube videos — competition highlights, catches and club events from Cornwall."
        keywords="RSAA YouTube, sea angling videos Cornwall, Redruth Sea Angling Association YouTube"
        url="https://www.redruthseaanglingassociation.co.uk/youtube"
      />
      <div className="mx-auto max-w-5xl px-6 py-16 sm:px-8 lg:px-12">

        <Link
          to="/"
          className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20"
        >
          ← Back
        </Link>

        <div className="mt-8">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Redruth Sea Angling Association</p>
          <div className="mt-3 flex items-center gap-4">
            <YouTubeIcon className="h-9 w-9 text-red-500 shrink-0" />
            <h1 className="heading-glow text-4xl font-bold tracking-tight text-white sm:text-5xl">YouTube Channels</h1>
          </div>
          <p className="mt-4 text-base leading-7 text-slate-400 max-w-2xl">
            A collection of YouTube channels we enjoy — from local Cornish fishing to UK sea angling, bass, lure fishing, and beyond.
          </p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((channel) => (
            <ChannelCard key={channel.handle} channel={channel} />
          ))}
        </div>

        <p className="mt-12 text-center text-xs text-slate-500">
          Know a channel we should include? Get in touch via the{" "}
          <Link to="/" className="text-cyan-400 hover:text-cyan-300 underline">contact section</Link> on our homepage.
        </p>

      </div>
    </div>
  );
}
